import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    intervoices: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_INTERVIDEO_SELECT_IDS (store, ids) {
      store.intervoices.selectIds = ids
    },
    REMOVE_INTERVIDEO_SELECT_IDS (store, ids) {
      store.intervoices.selectIds = store.intervoices.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_INTERVIDEO_SELECT_ID (store, id) {
      store.intervoices.selectId = id
    },
    SET_INTERVIDEO_FILTERS (store, filters) {
      store.intervoices.filters = filters
    },
    SET_INTERVIDEO_PAGINATE (store, val) {
      store.intervoices.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getIntervoices: (store, getters) => {
      return store.intervoices.selectIds.map((id) => {
        return getters['entities/intervoices/find'](id)
      })
    },
    getIntervoicesFilters: (store, getters) => {
      return store.intervoices.filters
    },
    getIntervoicesPaginate: (store, getters) => {
      return store.intervoices.paginate
    },
    getIntervoice: (store, getters) => {
      return getters['entities/intervoices/find'](store.intervoices.selectId) || {}
    }
  },
  actions: {
    /*
    selectIntervoices
    */
    selectIntervoices ({commit, dispatch, getters, state}, filters) {
      return dispatch('getIntervoices', filters)
      .then((response) => {
        commit('SET_INTERVIDEO_FILTERS', filters)
        commit('SET_INTERVIDEO_PAGINATE', response)
        commit('SET_INTERVIDEO_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectIntervoices
    */
    refreshSelectIntervoices ({commit, dispatch, getters, state}) {
      return dispatch('selectIntervoices', getters.getIntervoicesFilters)
    },
    /*
    selectIntervoice
    */
    selectIntervoice ({commit, dispatch, getters, state}, id) {
      return dispatch('getIntervoiceById', id)
      .then((response) => {
        commit('SET_INTERVIDEO_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getIntervoices
    */
    getIntervoices ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/intervoices`, {params: filters})
      .then((response) => {
        return dispatch('entities/intervoices/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.intervoices || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getIntervoiceById
    */
    getIntervoiceById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/intervoices/${id}`)
      .then((response) => {
        return dispatch('entities/intervoices/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.intervoices[0]
      })
    },
    /*
    createIntervoice
    */
    createIntervoice ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/intervoices`, data)
      .then((response) => {
        return dispatch('entities/intervoices/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.intervoices[0]
      })
    },
    /*
    updateIntervoice
    */
    updateIntervoice ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/intervoices/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/intervoices/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.intervoices[0]
      })
    },
    /*
    deleteIntervoice
    */
    deleteIntervoice ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/intervoices/${id}`)
      .then((response) => {
        commit('REMOVE_INTERVIDEO_SELECT_IDS', [id])
        dispatch('entities/intervoices/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Intervoice.js